module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/assessment_achievements/5_05e9920b7d171a45c3158ff40ef6c0dd.png";